<template>
    <div class="no-record">
        <keep-alive>
            <img class="no-record-img" v-bind:src="noImg" alt="">
        </keep-alive>
        <p>{{noteText}}</p>
        <p v-if="showButton" class="no-record-btn" @click="clickButton">{{buttonText}}</p>
    </div>
</template>

<script>
export default {
    name: 'NoData',
    props: {
        noteText: {
            type: String,
            default() { return '' }
        },
        showButton: {
            type: Boolean,
            default() { return false }
        },
        buttonText: {
            type: String,
            default() { return '' }
        },
        buttonFunc: {
            type: Function,
            default() { return null }
        }
    },
    data() {
        return {
            noImg: require('../../assets/images/no-data.png')
        }
    },
    methods: {
        clickButton() {
            if(this.buttonFunc && typeof(this.buttonFunc) == 'function') {
                this.buttonFunc();
            }
        }
    }
}
</script>